import { useEffect, useRef, useState } from 'react';
import { ContentCopy, ThumbUp } from '@lendi-ui/icon';
import Tooltip from '@lendi-ui/tooltip';

import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

import { LinkButton } from '../LinkButton';
import { TooltipContentContainer } from './index.style';

interface CopyButtonProps {
  textToCopy: string;
  label: string;
  trackingInfo?: { [key: string]: string };
}

const initialState: React.ReactNode = () => (
  <TooltipContentContainer>
    <ContentCopy width="18px" height="18px" />
    CLICK TO COPY
  </TooltipContentContainer>
);
const copiedState: React.ReactNode = () => (
  <TooltipContentContainer>
    <ThumbUp width="18px" height="18px" />
    COPIED
  </TooltipContentContainer>
);
export const CopyButton: React.FC<CopyButtonProps> = ({ textToCopy, label, trackingInfo }) => {
  const { tracking } = useAnalytics();
  const [content, setContent] = useState<React.ReactNode>(initialState);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isCopied, setIsCopied] = useState(false); // New state to track copied status

  const handleCopy = () => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setContent(copiedState);
        setIsCopied(true);
      })
      .catch((err) => {
        console.error('Failed to copy text:', err);
      });
  };
  useEffect(() => {
    if (isCopied) {
      timeoutRef.current = setTimeout(() => {
        setContent(initialState);
        setIsCopied(false);
      }, 1000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isCopied]);

  return (
    <Tooltip id="tooltip-copy-cv-link" content={content} position="bottom">
      <LinkButton
        before={<ContentCopy height={'18px'} width={'18px'} />}
        onClick={run(handleCopy, () =>
          tracking?.button.link({
            text: label,
            ...trackingInfo,
          })
        )}
        text={label}
      />
    </Tooltip>
  );
};
